import { PERIODS_VALUES } from '@app/constants/filters'

import type { LntSelectOption } from '@app/components/base/Select/types'

export const periodOptions: LntSelectOption[] = [
  { label: 'Дни', value: PERIODS_VALUES.date },
  { label: 'Недели', value: PERIODS_VALUES.week }
]
